<template>
  <div id="app">
    <v-container>
      <v-col :cols="12" style="margin:0; padding:0;">
        <v-row justify="center" align="center" class="mt-6">
          <v-col cols="12" sm="6" md="7" lg="6">
            <v-card class="mx-auto entercodebox" flat color="transparent">
              <v-card-text>
                <v-text-field
                  label="Enter Event Code"
                  outlined
                  v-model="code"
                  class="entercodeboxinput "
                  @keydown.enter="submitEventCode"
                ></v-text-field>
                <v-row>
                  <v-col cols="6">
                    <v-btn
                      @click="submitEventCode"
                      depressed
                      large
                      block
                      class="submitbutton hp--btn"
                      >Submit</v-btn
                    >
                  </v-col>
                  <v-col cols="6">
                    <v-btn
                      depressed
                      large
                      block
                      class="managebookingsbutton hp--btn"
                      @click="manageBooking"
                      >Manage my booking</v-btn
                    >
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <!--<Footer />-->
    </v-container>
  </div>
</template>

<script>
import Footer from "../components/Footer";
export default {
  data() {
    return {
      code: ""
    };
  },
  components: {
    Footer
  },
  methods: {
    submitEventCode() {
      this.$router.push({
        name: "bookevent",
        params: { eventcode: this.code }
      });
    },
    manageBooking() {
      this.$router.push({ name: "managebooking" });
    }
  }
};
</script>
